var data = {
	"body": "<path d=\"M166.872 131.237l45.91-79.275l22.184 79.275l-22.185 79.256l-45.909-79.256zm-22.376 12.874l45.916 79.262l-79.966-20.486l-57.77-58.776h91.82zm45.906-105.033l-45.906 79.275h-91.82l57.77-58.78l79.956-20.495zm65.539 65.18L227.933.06l-104.54 27.925l-15.475 27.207l-31.401-.225L0 131.244l76.517 76.259h.003l31.388-.232l15.497 27.207l104.528 27.92L255.94 158.22l-15.906-26.982l15.906-26.978z\" fill=\"#222C37\"/>",
	"width": 256,
	"height": 263
};
exports.__esModule = true;
exports.default = data;
